import { ArrowBackIcon, BlueBackIcon } from "assets/images/common/svgs";
import FormErrorMessage from "components/forms/form-error-message";
import useAuth from "containers/auth/useHook";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { BAGDE_TYPES, INDUSTRY_TYPES } from "utils/helpers/enums/shared.enum";
import { BadgeDTO } from "utils/helpers/models/badge/badge.dto";
import useBadges from "../../useHooks";
import { warningToaster } from "utils/helpers/common/alert-service";
import { useNavigate } from "react-router-dom";
import {
  BadgeFiltersDTO,
  CoreConceptFiltersDTO,
} from "utils/helpers/models/common/user-filters.dto";

const CreateCoreConceptBadge = () => {
  const [formData, setFormData] = useState<BadgeDTO>(new BadgeDTO());
  const [filters] = useState<CoreConceptFiltersDTO>(
    new CoreConceptFiltersDTO()
  );
  const [coreConcepts, setCoreConcepts] = useState<any[]>([]);
  const { uploadFile } = useAuth();
  const { createCoreConceptBadge, getAllCoreConcept, updateCoreConcept } =
    useBadges();
  const navigate = useNavigate();
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<BadgeDTO>();

  useEffect(() => {
    getAllCoreConcept(setCoreConcepts, { page: 0, size: 100 });
  }, []);

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { files } = event.target;
    const file = files[0];
    formData.imageUrl = file.name;
    const picture = await uploadFile(file);
    if (picture) {
      formData.imageId = picture.id;
    }
    setFormData({ ...formData });
  };

  const handleChange = (event: any) => {
    const {
      target: { name, value },
    } = event;
    setValue(name, value, { shouldValidate: true });
    setFormData({ ...formData, [name]: value });
  };

  const handleCoreConceptChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedId = Number(event.target.value);
    const selectedConcept = coreConcepts.find((c) => c.id === selectedId);

    setFormData({
      ...formData,
      coreConceptId: selectedId || null,
      name: selectedConcept ? selectedConcept.name : "",
    });
  };

  const onSubmit = async () => {
    console.log(formData, "formdata");

    if (!formData.imageId) {
      warningToaster("Badge image is required");
      return;
    } else if (!formData.coreConceptId) {
      warningToaster("Core Concept is required");
      return;
    }

    try {
      const response = await createCoreConceptBadge({
        ...formData,
        badgeType: BAGDE_TYPES.CORE_CONCEPT,
      });
      const newBadgeId = response?.data?.id;
      if (newBadgeId && formData.coreConceptId) {
        await updateCoreConcept(formData.coreConceptId, {
          badgeId: newBadgeId,
        });
      }
    } catch (error) {
      console.error("Error creating badge:", error);
    }
  };

  const goToBack = () => {
    navigate(-1);
  };

  return (
    <div className="">
      <h1 className="text-base text-primaryText font-bold flex items-center gap-3">
        <span
          onClick={goToBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        Create a new Badge
      </h1>
      <form onSubmit={handleSubmit(onSubmit)} className="mt-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 items-center">
          <div>
            <label className="block text-base font-semibold text-labelText mb-1">
              Core Concept
            </label>
            <select
              className="w-full h-[51px] border rounded-lg px-3 py-2 outline-none"
              onChange={handleCoreConceptChange}
              value={formData.coreConceptId ?? ""}
            >
              <option value="">Select Core Concept</option>
              {coreConcepts?.map((concept: any) =>
                !concept?.badgeId ? (
                  <option value={concept.id} key={concept.id}>
                    {concept?.name}
                  </option>
                ) : null
              )}
            </select>
          </div>

          <div>
            <label className="block text-base font-semibold text-labelText mb-1">
              Upload Badge
            </label>
            <div className="relative flex items-center">
              <label className="bg-gray-200  px-4 py-2 rounded-lg cursor-pointer">
                + Upload
                <input
                  type="file"
                  className="hidden"
                  onChange={handleFileChange}
                />
              </label>
              <span className="ml-2 text-gray-500 text-base">
                {formData.imageUrl ?? "Badge Size: 48 x 48 px"}
              </span>
            </div>
          </div>
        </div>
        <div className="mt-6">
          <button
            className="bg-darkSlateBlueBg text-white px-6 py-2 rounded-lg "
            type="submit"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateCoreConceptBadge;
